import Common from "../Common";

export interface CountryType {
	id: id
	name: string
	pbx_tz_id: id
	country_code: string
}

const Country = class extends Common {
	browse = (): CustomResponse<CountryType[]> =>
		this.get(`/country`)

	read = (countryId: id): CustomResponse<CountryType> =>
		this.get(`/country/${countryId}`)
}

export default Country
